function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertaintyOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "47.942 3.71 392.2393 487.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 432.279 66.219 L 252.119 4.824 C 249.944 4.083 247.029 3.71 244.113 3.71 C 241.198 3.71 238.282 4.083 236.109 4.824 L 55.948 66.219 C 51.548 67.705 47.942 72.793 47.942 77.459 L 47.942 333.225 C 47.942 337.891 50.966 344.04 54.623 346.956 L 237.378 489.368 C 239.236 490.798 241.62 491.541 244.061 491.541 C 246.501 491.541 248.937 490.798 250.743 489.368 L 433.499 346.956 C 437.159 344.095 440.179 337.944 440.179 333.225 L 440.179 77.459 C 440.286 72.793 436.68 67.758 432.279 66.219 Z M 402.111 323.047 L 244.113 446.158 L 86.116 323.047 L 86.116 96.334 L 244.113 42.468 L 402.111 96.334 L 402.111 323.047 Z",
    fill: "#93c6b6",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 86.116 96.334 L 86.116 323.047 L 244.113 446.158 L 402.111 323.047 L 402.111 96.334 L 244.113 42.468 L 86.116 96.334 Z",
    style: {
      fill: "#76e297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185.76 217.845 C 183.943 215.362 181.035 213.847 177.885 213.847 L 144.447 213.847 C 140.51 213.847 138.208 218.33 140.51 221.541 L 217.078 326.944 C 220.974 332.276 228.933 332.276 232.828 326.944 L 361.614 149.636 C 363.916 146.426 361.614 141.943 357.677 141.943 L 324.238 141.943 C 321.149 141.943 318.181 143.457 316.363 145.941 L 224.953 271.819 L 185.76 217.845 Z",
    style: {
      fill: "#233551"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertaintyOk);
export default __webpack_public_path__ + "static/media/certaintyOk.4124aaeef847263b47093d94b31f21a3.svg";
export { ForwardRef as ReactComponent };